/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Booking_Desc7Inputs */

const en_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reads real availability, books, reschedules and confirms. Clinics, real estate, restaurants and service businesses run on this.`)
};

const ar_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يقرأ التوافر الحقيقي ويحجز ويعيد الجدولة ويؤكد. العيادات والعقارات والمطاعم وشركات الخدمات تعمل بهذا.`)
};

const bn_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসল খালি সময় পড়ে, বুক করে, বদলায় আর নিশ্চিত করে। ক্লিনিক, রিয়েল এস্টেট, রেস্টুরেন্ট আর সার্ভিস ব্যবসা এটা দিয়েই চলে।`)
};

const de_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liest echte Verfügbarkeiten, bucht, verschiebt und bestätigt. Kliniken, Immobilien, Restaurants und Dienstleister arbeiten damit.`)
};

const es_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee la disponibilidad real, reserva, reprograma y confirma. Clínicas, inmobiliarias, restaurantes y negocios de servicios funcionan con esto.`)
};

const fr_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lit les disponibilités réelles, réserve, déplace et confirme. Cliniques, immobilier, restaurants et services fonctionnent avec ça.`)
};

const pt_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lê a disponibilidade real, agenda, remarca e confirma. Clínicas, imobiliárias, restaurantes e serviços funcionam com isto.`)
};

const zh_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取真实空闲时间，预订、改期并确认。诊所、房产、餐厅和服务行业都在用它运转。`)
};

const tr_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek uygunluğu okur, alır, erteler ve onaylar. Klinikler, emlakçılar, restoranlar ve hizmet işletmeleri bununla çalışır.`)
};

const ru_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читает реальную доступность, бронирует, переносит и подтверждает. Клиники, недвижимость, рестораны и сервисы работают на этом.`)
};

const pl_svc_ai_voice_agents_booking_desc7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Booking_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czyta prawdziwą dostępność, rezerwuje, przekłada i potwierdza. Kliniki, nieruchomości, restauracje i usługi działają właśnie na tym.`)
};

/**
* | output |
* | --- |
* | "Reads real availability, books, reschedules and confirms. Clinics, real estate, restaurants and service businesses run on this." |
*
* @param {Svc_Ai_Voice_Agents_Booking_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_booking_desc7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Booking_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Booking_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_booking_desc7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_booking_desc7(inputs)
	return en_svc_ai_voice_agents_booking_desc7(inputs)
});
export { svc_ai_voice_agents_booking_desc7 as "svc_ai-voice-agents_BOOKING_desc" }